import React from 'react';
import { useTranslation } from 'react-i18next';

const AdvanceStatusText = () => {
  const [t] = useTranslation();
  return (
    <>
      <p style={{ lineHeight: '26px', textAlign: 'justify' }}>
        {t('pages.data.advanceStatus.introText1')}
        <br />
        {t('pages.data.advanceStatus.introText2')}
      </p>
    </>
  );
};

export default AdvanceStatusText;
